export const API_HOST = location.host.replace("app.", "api.");
export const API_URL = `https://${API_HOST}`;
export const APP_HOSTNAME = location.host.replace("app.", "");
export const WEBSITE_URL = `https://${APP_HOSTNAME}`;
